module.exports = __webpack_public_path__ + "img/Mason-logo.jpg.4fc48c99.webp";